import InspectionDetailNode from './InspectionDetailNode';
export default InspectionDetailNode;
